export default __webpack_public_path__ + "static/media/embed-credential.d208d57e.svg";